import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'
import type { User } from '~/types/auth'

export const users = createQueryKeys('users', {
  me: null,
  details: (userId: User['id']) => [userId],
  agent: (userId: User['id']) => [userId],
  allPaginated: (query?: any) => [query],
})

export type CountryKeys = inferQueryKeys<typeof users>
